<script lang="ts">
	import type { PlainFooterData } from './types';
	import SEOFooterLinkBlock from './SEOFooterLinkBlock.svelte';

	interface Props {
		data: PlainFooterData;
	}

	const { data }: Props = $props();
	const { footerLinks, topSearchLinks, allViamichelnLinks } = data;
</script>

<section class="flex flex-col gap-0 p-0 m-0">
	{#if footerLinks}
		{#each footerLinks as footerLink, index (`${footerLink.label}-${index}`)}
			<SEOFooterLinkBlock title={footerLink.label} links={footerLink.links} />
		{/each}
	{/if}

	{#if topSearchLinks}
		{#each topSearchLinks as topSearchLink, index (`${topSearchLink.label}-${index}`)}
			<SEOFooterLinkBlock title={topSearchLink.label} links={topSearchLink.links} testid="seo-footer-top-search-block" />
		{/each}
	{/if}

	{#if allViamichelnLinks}
		{#each allViamichelnLinks as allViamichelnLink, index (`${allViamichelnLink.label}-${index}`)}
			<SEOFooterLinkBlock title={allViamichelnLink.label} links={allViamichelnLink.links} testid="seo-footer-all-viamicheln-block" />
		{/each}
	{/if}
</section>
